// @generated by TypeGen from LogbookModel/Schema - DO NOT EDIT

import type { IAccount } from "./Account"
import type { IAccountSubscriptionPlan, IAccountSubscriptionPlanFeature, IAccountSubscriptionPlanPricing } from "./AccountSubscriptionPlan"
import type { IAccountUser } from "./AccountUser"
import type { IAuditLogEdit } from "./AuditLogEdit"
import type { ICruise } from "./Cruise"
import type { IDataRecord } from "./DataRecord"
import type { IDay } from "./Day"
import type { ILog } from "./Log"
import type { INote } from "./Note"
import type { INoteAttachment } from "./NoteAttachment"
import type { ISettings } from "./Settings"
import type { IShip } from "./Ship"
import type { IShipUser } from "./ShipUser"
import type { IStatus } from "./Status"
import type { IStoredCalculation } from "./StoredCalculation"
import type { ITrack } from "./Track"
import type { ITrip } from "./Trip"
import type { IUser } from "./User"

export const SchemaEntities = {
  Account: "Account",
  AccountSubscriptionPlan: "AccountSubscriptionPlan",
  AccountSubscriptionPlanFeature: "AccountSubscriptionPlanFeature",
  AccountSubscriptionPlanPricing: "AccountSubscriptionPlanPricing",
  AccountUser: "AccountUser",
  AuditLogEdit: "AuditLogEdit",
  Cruise: "Cruise",
  DataRecord: "DataRecord",
  Day: "Day",
  Log: "Log",
  Note: "Note",
  NoteAttachment: "NoteAttachment",
  Settings: "Settings",
  Ship: "Ship",
  ShipUser: "ShipUser",
  Status: "Status",
  StoredCalculation: "StoredCalculation",
  Track: "Track",
  Trip: "Trip",
  User: "User",
} as const;

export type SchemaEntity =
  | typeof SchemaEntities.Account
  | typeof SchemaEntities.AccountSubscriptionPlan
  | typeof SchemaEntities.AccountSubscriptionPlanFeature
  | typeof SchemaEntities.AccountSubscriptionPlanPricing
  | typeof SchemaEntities.AccountUser
  | typeof SchemaEntities.AuditLogEdit
  | typeof SchemaEntities.Cruise
  | typeof SchemaEntities.DataRecord
  | typeof SchemaEntities.Day
  | typeof SchemaEntities.Log
  | typeof SchemaEntities.Note
  | typeof SchemaEntities.NoteAttachment
  | typeof SchemaEntities.Settings
  | typeof SchemaEntities.Ship
  | typeof SchemaEntities.ShipUser
  | typeof SchemaEntities.Status
  | typeof SchemaEntities.StoredCalculation
  | typeof SchemaEntities.Track
  | typeof SchemaEntities.Trip
  | typeof SchemaEntities.User;

export interface SchemaEntityTypes {
  Account: IAccount;
  AccountSubscriptionPlan: IAccountSubscriptionPlan;
  AccountSubscriptionPlanFeature: IAccountSubscriptionPlanFeature;
  AccountSubscriptionPlanPricing: IAccountSubscriptionPlanPricing;
  AccountUser: IAccountUser;
  AuditLogEdit: IAuditLogEdit;
  Cruise: ICruise;
  DataRecord: IDataRecord;
  Day: IDay;
  Log: ILog;
  Note: INote;
  NoteAttachment: INoteAttachment;
  Settings: ISettings;
  Ship: IShip;
  ShipUser: IShipUser;
  Status: IStatus;
  StoredCalculation: IStoredCalculation;
  Track: ITrack;
  Trip: ITrip;
  User: IUser;
}

export interface SchemaEntityFkFields {
  Account: never;
  AccountSubscriptionPlan: never;
  AccountSubscriptionPlanFeature: "accountSubscriptionPlanId";
  AccountSubscriptionPlanPricing: "accountSubscriptionPlanId";
  AccountUser: "accountId" | "userId";
  AuditLogEdit: "accountId" | "cruiseId" | "dayId" | "logId" | "shipId" | "shipUserId" | "tripId";
  Cruise: "accountId" | "shipId";
  DataRecord: "accountId" | "cruiseId" | "dayId" | "logId" | "parentId" | "shipId" | "statusId" | "tripId" | "userId";
  Day: "accountId" | "cruiseId" | "shipId" | "tripId";
  Log: "accountId" | "cruiseId" | "dayId" | "shipId" | "tripId" | "userId";
  Note: "accountId" | "cruiseId" | "dayId" | "logId" | "shipId" | "tripId" | "userId";
  NoteAttachment: "accountId" | "noteId" | "shipId" | "userId";
  Settings: "accountId" | "shipId" | "userId";
  Ship: "accountId" | "tenderToId";
  ShipUser: "accountId" | "shipId" | "userId";
  Status: "accountId" | "cruiseId" | "dayId" | "endLogId" | "shipId" | "startLogId" | "tripId" | "userId";
  StoredCalculation: "accountId" | "shipId" | "sourceId";
  Track: "accountId" | "cruiseId" | "dayId" | "monitorStatusId" | "shipId" | "tripId";
  Trip: "accountId" | "cruiseId" | "shipId";
  User: "accountId";
}

export type SchemaEdgeKind = "owner" | "index" | "role" | "polymorphic";

export interface SchemaEdge {
  from: SchemaEntity;
  to: SchemaEntity;
  fkField: string;
  optional: boolean;
  canonical: boolean;
  kind: SchemaEdgeKind;
  discriminant?: string;
}

export const schemaEdges: readonly SchemaEdge[] = [
  { from: "AccountSubscriptionPlan", to: "AccountSubscriptionPlanFeature", fkField: "accountSubscriptionPlanId", optional: false, canonical: true, kind: "owner" },
  { from: "AccountSubscriptionPlan", to: "AccountSubscriptionPlanPricing", fkField: "accountSubscriptionPlanId", optional: false, canonical: true, kind: "owner" },
  { from: "Account", to: "AccountUser", fkField: "accountId", optional: false, canonical: true, kind: "owner" },
  { from: "User", to: "AccountUser", fkField: "userId", optional: false, canonical: false, kind: "index" },
  { from: "Account", to: "AuditLogEdit", fkField: "accountId", optional: false, canonical: false, kind: "index" },
  { from: "Cruise", to: "AuditLogEdit", fkField: "cruiseId", optional: true, canonical: false, kind: "index" },
  { from: "Day", to: "AuditLogEdit", fkField: "dayId", optional: true, canonical: false, kind: "index" },
  { from: "Log", to: "AuditLogEdit", fkField: "logId", optional: true, canonical: false, kind: "index" },
  { from: "Ship", to: "AuditLogEdit", fkField: "shipId", optional: false, canonical: false, kind: "index" },
  { from: "ShipUser", to: "AuditLogEdit", fkField: "shipUserId", optional: false, canonical: true, kind: "owner" },
  { from: "Trip", to: "AuditLogEdit", fkField: "tripId", optional: true, canonical: false, kind: "index" },
  { from: "Account", to: "Cruise", fkField: "accountId", optional: false, canonical: false, kind: "index" },
  { from: "Ship", to: "Cruise", fkField: "shipId", optional: false, canonical: true, kind: "owner" },
  { from: "Account", to: "DataRecord", fkField: "accountId", optional: false, canonical: false, kind: "index" },
  { from: "Cruise", to: "DataRecord", fkField: "cruiseId", optional: true, canonical: false, kind: "index" },
  { from: "DataRecord", to: "DataRecord", fkField: "parentId", optional: true, canonical: false, kind: "role" },
  { from: "Day", to: "DataRecord", fkField: "dayId", optional: true, canonical: false, kind: "index" },
  { from: "Log", to: "DataRecord", fkField: "logId", optional: true, canonical: false, kind: "index" },
  { from: "Ship", to: "DataRecord", fkField: "shipId", optional: false, canonical: true, kind: "owner" },
  { from: "Status", to: "DataRecord", fkField: "statusId", optional: true, canonical: false, kind: "index" },
  { from: "Trip", to: "DataRecord", fkField: "tripId", optional: true, canonical: false, kind: "index" },
  { from: "User", to: "DataRecord", fkField: "userId", optional: true, canonical: false, kind: "index" },
  { from: "Account", to: "Day", fkField: "accountId", optional: false, canonical: false, kind: "index" },
  { from: "Cruise", to: "Day", fkField: "cruiseId", optional: false, canonical: false, kind: "index" },
  { from: "Ship", to: "Day", fkField: "shipId", optional: false, canonical: false, kind: "index" },
  { from: "Trip", to: "Day", fkField: "tripId", optional: false, canonical: true, kind: "owner" },
  { from: "Account", to: "Log", fkField: "accountId", optional: false, canonical: false, kind: "index" },
  { from: "Cruise", to: "Log", fkField: "cruiseId", optional: false, canonical: false, kind: "index" },
  { from: "Day", to: "Log", fkField: "dayId", optional: false, canonical: true, kind: "owner" },
  { from: "Ship", to: "Log", fkField: "shipId", optional: false, canonical: false, kind: "index" },
  { from: "Trip", to: "Log", fkField: "tripId", optional: false, canonical: false, kind: "index" },
  { from: "User", to: "Log", fkField: "userId", optional: true, canonical: false, kind: "index" },
  { from: "Account", to: "Note", fkField: "accountId", optional: false, canonical: false, kind: "index" },
  { from: "Cruise", to: "Note", fkField: "cruiseId", optional: true, canonical: false, kind: "index" },
  { from: "Day", to: "Note", fkField: "dayId", optional: true, canonical: false, kind: "index" },
  { from: "Log", to: "Note", fkField: "logId", optional: true, canonical: false, kind: "index" },
  { from: "Ship", to: "Note", fkField: "shipId", optional: false, canonical: true, kind: "owner" },
  { from: "Trip", to: "Note", fkField: "tripId", optional: true, canonical: false, kind: "index" },
  { from: "User", to: "Note", fkField: "userId", optional: true, canonical: false, kind: "index" },
  { from: "Account", to: "NoteAttachment", fkField: "accountId", optional: false, canonical: false, kind: "index" },
  { from: "Note", to: "NoteAttachment", fkField: "noteId", optional: false, canonical: true, kind: "owner" },
  { from: "Ship", to: "NoteAttachment", fkField: "shipId", optional: false, canonical: false, kind: "index" },
  { from: "User", to: "NoteAttachment", fkField: "userId", optional: true, canonical: false, kind: "index" },
  { from: "Account", to: "Settings", fkField: "accountId", optional: false, canonical: false, kind: "index" },
  { from: "Ship", to: "Settings", fkField: "shipId", optional: false, canonical: true, kind: "owner" },
  { from: "User", to: "Settings", fkField: "userId", optional: false, canonical: false, kind: "index" },
  { from: "Account", to: "Ship", fkField: "accountId", optional: false, canonical: true, kind: "owner" },
  { from: "Ship", to: "Ship", fkField: "tenderToId", optional: true, canonical: false, kind: "role" },
  { from: "Account", to: "ShipUser", fkField: "accountId", optional: false, canonical: false, kind: "index" },
  { from: "Ship", to: "ShipUser", fkField: "shipId", optional: false, canonical: true, kind: "owner" },
  { from: "User", to: "ShipUser", fkField: "userId", optional: true, canonical: false, kind: "index" },
  { from: "Account", to: "Status", fkField: "accountId", optional: false, canonical: false, kind: "index" },
  { from: "Cruise", to: "Status", fkField: "cruiseId", optional: false, canonical: false, kind: "index" },
  { from: "Day", to: "Status", fkField: "dayId", optional: false, canonical: true, kind: "owner" },
  { from: "Log", to: "Status", fkField: "endLogId", optional: true, canonical: false, kind: "role" },
  { from: "Log", to: "Status", fkField: "startLogId", optional: false, canonical: false, kind: "role" },
  { from: "Ship", to: "Status", fkField: "shipId", optional: false, canonical: false, kind: "index" },
  { from: "Trip", to: "Status", fkField: "tripId", optional: false, canonical: false, kind: "index" },
  { from: "User", to: "Status", fkField: "userId", optional: true, canonical: false, kind: "index" },
  { from: "Account", to: "StoredCalculation", fkField: "accountId", optional: false, canonical: false, kind: "index" },
  { from: "Cruise", to: "StoredCalculation", fkField: "sourceId", optional: false, canonical: false, kind: "polymorphic", discriminant: "3" },
  { from: "Day", to: "StoredCalculation", fkField: "sourceId", optional: false, canonical: false, kind: "polymorphic", discriminant: "1" },
  { from: "Log", to: "StoredCalculation", fkField: "sourceId", optional: false, canonical: false, kind: "polymorphic", discriminant: "4" },
  { from: "Ship", to: "StoredCalculation", fkField: "shipId", optional: false, canonical: true, kind: "owner" },
  { from: "Ship", to: "StoredCalculation", fkField: "sourceId", optional: false, canonical: false, kind: "polymorphic", discriminant: "6" },
  { from: "Status", to: "StoredCalculation", fkField: "sourceId", optional: false, canonical: false, kind: "polymorphic", discriminant: "5" },
  { from: "Trip", to: "StoredCalculation", fkField: "sourceId", optional: false, canonical: false, kind: "polymorphic", discriminant: "2" },
  { from: "Account", to: "Track", fkField: "accountId", optional: false, canonical: false, kind: "index" },
  { from: "Cruise", to: "Track", fkField: "cruiseId", optional: false, canonical: true, kind: "owner" },
  { from: "Day", to: "Track", fkField: "dayId", optional: true, canonical: false, kind: "index" },
  { from: "Ship", to: "Track", fkField: "shipId", optional: false, canonical: false, kind: "index" },
  { from: "Status", to: "Track", fkField: "monitorStatusId", optional: true, canonical: false, kind: "role" },
  { from: "Trip", to: "Track", fkField: "tripId", optional: true, canonical: false, kind: "index" },
  { from: "Account", to: "Trip", fkField: "accountId", optional: false, canonical: false, kind: "index" },
  { from: "Cruise", to: "Trip", fkField: "cruiseId", optional: false, canonical: true, kind: "owner" },
  { from: "Ship", to: "Trip", fkField: "shipId", optional: false, canonical: false, kind: "index" },
  { from: "Account", to: "User", fkField: "accountId", optional: true, canonical: false, kind: "owner" },
] as const;
